import DatePicker from '../date-picker/DatePicker';
import { Box, styled } from '@mui/material';

export const DateSelectContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  gap: 25px;
`;

export const DatePickerContainer = styled(Box)`
  width: 100%;
  .MuiStack-root {
    padding: 0;
  }
  .MuiFormControl-root {
    width: 100%;
  }
`;

export const StyledDatePicker = styled(DatePicker)``;
